<template>
  <div class="find-pas">
    <div class="top2"></div>
    <input type="password" placeholder="请输入新密码" v-model="pass">
    <input type="password" placeholder="请再次输入新密码" v-model="repass">
    <div class="wrongs" v-show="errorShow">{{errorMsg}}</div>
    <div class="login-btn" @click="sure">确定</div>
    <successalert :show="show" :msg="msg"></successalert>
  </div>
</template>

<script>
  import mixin from '../../js/public.js';
  import successalert from '../successalert/successalert.vue';

  export default{
    mixins: [mixin],
    components: {
      successalert
    },
    data () {
      return {
        errorMsg: '',
        errorShow: false,
        pass: '',
        repass: '',
        show: false,
        msg: '恭喜你，密码修改成功！',
        e: '',
        code: ''
      };
    },
    created () {
      this.e = this.getUrlFn('e');
      this.code = this.getUrlFn('code');
    },
    methods: {
      /* 确定修改密码 */
      sure () {
        var _this = this;
        var re = /^\d+$/;
        var re1 = /^[a-zA-Z]+$/;
        var re2 = /^[`~!@#\$%\^&\*\(\)_\+<>\?:"\{\},\.\\\/;'\[\]！。；、’“”]+$/;
        var val = this.pass;
        var len = val.length;
        if (re.test(val) || re1.test(val) || re2.test(val) || len > 16 || len < 6) {
          this.errorMsg = '密码需要6-16位，且必须包含两种以上字符';
          this.errorShow = true;
          return;
        }
        this.errorShow = false;
        if (this.pass !== this.repass) {
          this.errorMsg = '两次输入的密码不一样，请重新输入';
          this.errorShow = true;
          return;
        }
        this.$http.post(_this.baseUrl + '/find/password/modify/2', {e: this.e, code: this.code, password: this.pass}, {credentials: true}).then(function (res) {
          if (res.body.type === 'success') {
            _this.show = true;
            window.location = '/sso-web/';
          } else {
            _this.errorMsg = '修改密码失败';
            _this.errorShow = true;
          }
        }, function () {
          _this.errorMsg = '网络错误，请稍后重试';
          _this.errorShow = true;
        });
      }
    }
  };
</script>

<style lang="scss" scoped="" type="text/css">
  @import "../../css/findPas.scss";
</style>



// WEBPACK FOOTER //
// newPas.vue?53b6eb84